// extracted by mini-css-extract-plugin
export default {"item":"LegendItem_item__q44rw","prefix":"LegendItem_prefix__YhamH","label":"LegendItem_label__fneNv","networkCoverageLegend":"LegendItem_networkCoverageLegend__PID04"};